"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runCallbacks = exports.onSessionExpired = exports.onLogout = exports.onEnhanceAuthenticationResult = void 0;
const vue_1 = require("vue");
const registeredCallbacks = {
    enhanceAuthenticationResult: [],
    logout: [],
    sessionExpired: []
};
function registerCallback(type, callback) {
    registeredCallbacks[type].push(callback);
}
function unregisterCallback(type, callback) {
    const callbackIndex = registeredCallbacks[type].indexOf(callback);
    if (callbackIndex > -1) {
        registeredCallbacks[type].splice(callbackIndex, 1);
    }
}
function onEnhanceAuthenticationResult(callback) {
    if ((0, vue_1.getCurrentInstance)()) {
        (0, vue_1.onUnmounted)(() => {
            unregisterCallback('enhanceAuthenticationResult', callback);
        });
    }
    registerCallback('enhanceAuthenticationResult', callback);
    return function remove() {
        unregisterCallback('enhanceAuthenticationResult', callback);
    };
}
exports.onEnhanceAuthenticationResult = onEnhanceAuthenticationResult;
function onLogout(callback) {
    if ((0, vue_1.getCurrentInstance)()) {
        (0, vue_1.onUnmounted)(() => {
            unregisterCallback('logout', callback);
        });
    }
    registerCallback('logout', callback);
    return function remove() {
        unregisterCallback('logout', callback);
    };
}
exports.onLogout = onLogout;
function onSessionExpired(callback) {
    if ((0, vue_1.getCurrentInstance)()) {
        (0, vue_1.onUnmounted)(() => {
            unregisterCallback('sessionExpired', callback);
        });
    }
    registerCallback('sessionExpired', callback);
    return function remove() {
        unregisterCallback('sessionExpired', callback);
    };
}
exports.onSessionExpired = onSessionExpired;
function runCallbacks(type, arg) {
    return __awaiter(this, void 0, void 0, function* () {
        let returnValue = undefined;
        for (const callback of registeredCallbacks[type]) {
            const potentialReturnValue = yield callback(arg);
            if (potentialReturnValue !== undefined) {
                returnValue = potentialReturnValue;
            }
        }
        return returnValue;
    });
}
exports.runCallbacks = runCallbacks;
//# sourceMappingURL=lifecycle-hooks.js.map